import { InjectableRxStompConfig } from "@stomp/ng2-stompjs";
import { APIUrl } from "src/app/features-common/constants/APIUrls";
import { environment } from "src/environments/environment";

export const WsStompConfig: InjectableRxStompConfig = {
  // Which server?
  brokerURL: `${environment.socketUrl}:${environment.port}/messages`,

  // Headers
  // Typical keys: login, passcode, host
  connectHeaders: {
    login: "guest",
    passcode: "guest",
  },

  // How often to heartbeat?
  // Interval in milliseconds, set to 0 to disable
  heartbeatIncoming: 4000, // Typical value 0 - disabled

  heartbeatOutgoing: 4000, // Typical value 20000 - every 20 seconds

  // Wait in milliseconds before attempting auto reconnect
  // Set to 0 to disable
  // Typical value 5000 (5 seconds)
  reconnectDelay: 5000,

  // Will log diagnostics on console
  // It can be quite verbose, not recommended in production
  // Skip this key to stop logging to console
  debug: (msg: string): void => {
    console.log(new Date(), msg);
  },
};
